import TRWReelCascadeBehaviour from './spinner/TRWReelCascadeBehaviour'
import Reel from "../../vendor_core/core/src/views/Reel";
import ReelSymbol from "../../vendor_core/core/src/views/Symbol";
import GameFactory from "../../vendor_core/src/factories/GameFactory";
import TRWCascadeReelGroup from "./view/TRWCascadeReelGroup";
import TRWAnticipation from "./view/TRWAnticipation";
import TRWUIView from "./view/TRWUIView";
import TRWWinSymbolsView from "./view/TRWWinSymbolsView";
import TRWWinlinesView from "./view/TRWWinlinesView";
import TRWSettings from './view/TRWSettings';
import BaseSettings from "../../vendor_core/core/src/ui/BaseSettings";
import TRWPreloadView from './view/TRWPreloadView';

/**
 * Factory for creating game specific objects
 */
class TRWGameFactory extends GameFactory {

    protected getAnticipation(): TRWAnticipation {
        return new TRWAnticipation();
    }

    protected getWinSymbolsView(): TRWWinSymbolsView {
        return new TRWWinSymbolsView();
    }

    protected getWinlinesView(): TRWWinlinesView {
        return new TRWWinlinesView();
    }

    protected getReelGroup(): TRWCascadeReelGroup {
        return new TRWCascadeReelGroup();
    }

    protected getUIView(): TRWUIView {
        return new TRWUIView();
    }

    protected getSymbol(): ReelSymbol {
        return new ReelSymbol();
    }

    protected getSettings(): BaseSettings {
        return new TRWSettings();
    }

    protected getFreeSpinBehaviour(params: { reel: Reel; sortFunction: any }): TRWReelCascadeBehaviour {
        return new TRWReelCascadeBehaviour(params.reel, params.sortFunction);
    }

    protected getRespinBehaviour(params: { reel: Reel; sortFunction: any }): TRWReelCascadeBehaviour {
        return new TRWReelCascadeBehaviour(params.reel, params.sortFunction);
    }

    protected getSpinBehaviour(params: { reel: Reel; sortFunction: any }): TRWReelCascadeBehaviour {
        return new TRWReelCascadeBehaviour(params.reel, params.sortFunction);
    }

    protected getPreloadView(): TRWPreloadView {
        return new TRWPreloadView();
    }
}

export default TRWGameFactory;
